export const CATEGORY_SECURITY = 'SEGURANÇA';
export const CATEGORY_COMFORT = 'CONFORTO';
export const CATEGORY_SOUND = 'SOM';
export const CATEGORY_SEATS = 'BANCOS';
export const CATEGORY_WINDOWS = 'JANELAS';
export const CATEGORY_OTHER = 'OUTROS';
